// Cancel order
export const CANCELORDER_SUBMIT = 'CANCELORDER_SUBMIT';
export const CANCELORDER_SUBMIT_SUCCESS = 'CANCELORDER_SUBMIT_SUCCESS';
export const CANCELORDER_SUBMIT_ERROR = 'CANCELORDER_SUBMIT_ERROR';
